import { useState } from 'react';

import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

/**
 * Collapsible Advanced Settings section for voice integrations.
 *
 * Hidden by default; local state only, so navigating away (unmount) resets it to collapsed.
 * Children (language-derived advanced cards) render only while expanded.
 */
const AdvancedSettings = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex w-full flex-col gap-12">
      <div className="flex items-center gap-2">
        <div className="h-px flex-1 bg-stroke" />
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => setOpen((prev) => !prev)}
          className="text-informational"
          aria-expanded={open}
          aria-controls="advanced-settings-content"
        >
          {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
          {open
            ? t('integrations.voice_common.advanced.hide')
            : t('integrations.voice_common.advanced.show')}
        </Button>
        <div className="h-px flex-1 bg-stroke" />
      </div>
      {open ? (
        <div id="advanced-settings-content" className="flex flex-col gap-12">
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default AdvancedSettings;
